import * as PIXI from 'pixi.js'
import { Point, Scale, Size } from '../multigame/MyHelpers';
import { GetOrientation, Orientation } from '../multigame/FitScreen';

export interface ContainerDebugParams
{
    color?: PIXI.ColorSource;
    secondaryColor?: PIXI.ColorSource;
    name?: string;
}


export class FixedSizeFitContainer extends PIXI.Container
{

    public fixedWidth: number;
    public fixedHeight: number;
    public debugParams: ContainerDebugParams;
    public debugGraphics: PIXI.Graphics = null;

    public constructor(width: number, height: number, debugParams?: ContainerDebugParams)
    {
        super();
        this.fixedWidth = width;
        this.fixedHeight = height;
        this.debugParams = debugParams;
        this.name = debugParams?.name;

        if (this.debugParams?.color)
        {
            // this.debugGraphics = new PIXI.Graphics();
            // this.debugGraphics.name = this.debugParams?.name ?? "debugGraphics";

            // this.debugGraphics.beginFill(this.debugParams?.color ?? 'red');
            // this.debugGraphics.drawRect(0, 0, this.fixedWidth, this.fixedHeight);
            // this.debugGraphics.endFill();

            // this.addChild(this.debugGraphics);
        }
    }


    public prevParentWidth: number;
    public prevParentHeight: number;

    public calculatedWidth: number;
    public calculatedHeight: number;

    override updateTransform(): void
    {



        if (this.parent)
        {
            let parentWidth: number;
            let parentHeight: number;

            if (this.parent instanceof ResponsiveView)
            {
                parentWidth = this.parent.availableWidth;
                parentHeight = this.parent.availableHeight;
            }
            else if (this.parent instanceof FixedSizeFitContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }
            else if (this.parent instanceof ResponsiveSizeContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }

            const parentSizeChanged = this.prevParentWidth != parentWidth || this.prevParentHeight != parentHeight;
            if (parentSizeChanged)
            {
                //console.log(`FixedSizeContainer() ${this.name} parentWidth: ${parentWidth}, parentHeight: ${parentHeight}`);
                
                const scalex = parentWidth / this.fixedWidth;
                const scaley = parentHeight / this.fixedHeight;

                const minscale = Math.min(scalex, scaley);

                //console.log(`FixedSizeContainer() ${this.name} scalex: ${scalex}, scaley: ${scaley}, minscale: ${minscale}`);

                // center position relative to parent
                this.calculatedWidth = Math.round(this.fixedWidth * minscale);
                this.calculatedHeight = Math.round(this.fixedHeight * minscale);

                this.position.set(parentWidth / 2 - this.calculatedWidth / 2, parentHeight / 2 - this.calculatedHeight / 2);

                this.scale.set(minscale, minscale);

                this.prevParentWidth = parentWidth;
                this.prevParentHeight = parentHeight;
            }
        }

        super.updateTransform();
    }
}

export class FixedSizeCoverContainer extends PIXI.Container
{

    public fixedWidth: number;
    public fixedHeight: number;
    public debugParams: ContainerDebugParams;
    public debugGraphics: PIXI.Graphics = null;

    public constructor(width: number, height: number, debugParams?: ContainerDebugParams)
    {
        super();
        this.fixedWidth = width;
        this.fixedHeight = height;
        this.debugParams = debugParams;
        this.name = debugParams?.name;

        if (this.debugParams?.color)
        {
            // this.debugGraphics = new PIXI.Graphics();
            // this.debugGraphics.name = this.debugParams?.name ?? "debugGraphics";

            // this.debugGraphics.beginFill(this.debugParams?.color ?? 'red');
            // this.debugGraphics.drawRect(0, 0, this.fixedWidth, this.fixedHeight);
            // this.debugGraphics.endFill();

            // this.addChild(this.debugGraphics);
        }
    }


    public prevParentWidth: number;
    public prevParentHeight: number;

    public calculatedWidth: number;
    public calculatedHeight: number;

    override updateTransform(): void
    {



        if (this.parent)
        {
            let parentWidth: number;
            let parentHeight: number;

            if (this.parent instanceof ResponsiveView)
            {
                parentWidth = this.parent.availableWidth;
                parentHeight = this.parent.availableHeight;
            }
            else if (this.parent instanceof FixedSizeFitContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }
            else if (this.parent instanceof ResponsiveSizeContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }

            const parentSizeChanged = this.prevParentWidth != parentWidth || this.prevParentHeight != parentHeight;
            if (parentSizeChanged)
            {
                console.log(`FixedSizeContainer() ${this.name} parentWidth: ${parentWidth}, parentHeight: ${parentHeight}`);
                
                const scalex = parentWidth / this.fixedWidth;
                const scaley = parentHeight / this.fixedHeight;

                const minscale = Math.max(scalex, scaley);

                console.log(`FixedSizeContainer() ${this.name} scalex: ${scalex}, scaley: ${scaley}, minscale: ${minscale}`);

                // center position relative to parent
                this.calculatedWidth = Math.round(this.fixedWidth * minscale);
                this.calculatedHeight = Math.round(this.fixedHeight * minscale);

                this.position.set(parentWidth / 2 - this.calculatedWidth / 2, parentHeight / 2 - this.calculatedHeight / 2);

                this.scale.set(minscale, minscale);

                this.prevParentWidth = parentWidth;
                this.prevParentHeight = parentHeight;
            }
        }

        super.updateTransform();
    }
}

export class ResponsiveSizeContainer extends PIXI.Container
{
    
    public percentX: number;
    public percentY: number;
    public percentWidth: number;
    public percentHeight: number;

    public maxRatio: number;

    public debugParams: ContainerDebugParams;


    public calculatedX: number;
    public calculatedY: number;
    public calculatedWidth: number;
    public calculatedHeight: number;

    public debugGraphics: PIXI.Graphics = null;

    public constructor(percentX: number, percentY: number, percentWidth: number, percentHeight: number, maxRatio: number = NaN, debugParams?: ContainerDebugParams)
    {
        super();
        this.percentX = percentX;
        this.percentY = percentY;
        this.percentWidth = percentWidth;
        this.percentHeight = percentHeight;
        this.maxRatio = maxRatio;
        this.debugParams = debugParams;
        this.name = debugParams?.name;

        if (this.debugParams?.color)
        {
            // this.debugGraphics = new PIXI.Graphics();
            // this.debugGraphics.name = this.debugParams?.name ?? "debugGraphics";
            // this.addChild(this.debugGraphics);
        }
    }

    protected updateDebugGraphics(): void
    {
        if (!this.debugGraphics)
        {
            // no debug graphics
            return;
        }

        // this.debugGraphics.clear();
        // this.debugGraphics.beginFill(this.debugParams?.color ?? colorGenerator.getContrastedRandomColor());
        // this.debugGraphics.drawRect(0, 0, this.calculatedWidth, this.calculatedHeight);
        // this.debugGraphics.endFill();
    }

    override updateTransform(): void
    {
        let parentWidth: number;
        let parentHeight: number;

        if (this.parent)
        {
            if (this.parent instanceof ResponsiveView)
            {
                parentWidth = this.parent.availableWidth;
                parentHeight = this.parent.availableHeight;
            }
            else if (this.parent instanceof FixedSizeFitContainer)
            {
                parentWidth = this.parent.fixedWidth;
                parentHeight = this.parent.fixedHeight;
            }
            else if (this.parent instanceof ResponsiveSizeContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }

            let newX = Math.round(parentWidth * this.percentX);
            let newY = Math.round(parentHeight * this.percentY);

            let newCalculatedWidth = Math.round(parentWidth * this.percentWidth);
            let newCalculatedHeight = Math.round(parentHeight * this.percentHeight);

            let naturalRatio = newCalculatedWidth / newCalculatedHeight;

            if (!isNaN(this.maxRatio))
            {
                if (naturalRatio > this.maxRatio)
                {

                    // limit new calculated size to the max ratio
                    let limitedWidth = Math.round(newCalculatedHeight * this.maxRatio);
                    newX = (newCalculatedWidth - limitedWidth) / 2;
                    newCalculatedWidth = limitedWidth;
                }
            }
            const ratio = newCalculatedWidth / newCalculatedHeight;

            const sizeChanged = this.calculatedWidth != newCalculatedWidth || this.calculatedHeight != newCalculatedHeight;

            // if new size is different
            if (sizeChanged)
            {
                //console.log(`ResponsiveSizeContainer.updateTransform() ${this.name} (percent size: ${this.percentX}x${this.percentY} ${this.percentWidth}x${this.percentHeight}) parent size: ${parentWidth}x${parentHeight}, calculated +${this.calculatedX}+${this.calculatedY} ${this.calculatedWidth}x${this.calculatedHeight}, naturalRatio ${naturalRatio} ratio ${ratio} maxratio ${this.maxRatio}`); 
            }

            this.updateDebugGraphics();


            this.calculatedWidth = newCalculatedWidth;
            this.calculatedHeight = newCalculatedHeight;
            this.calculatedX = newX;
            this.calculatedY = newY;

            this.position.set(this.calculatedX, this.calculatedY);
        }

        super.updateTransform();
    }
}

export class ResponsiveView extends PIXI.Container
{
    public debugParams: ContainerDebugParams;
    public availableWidth: number;
    public availableHeight: number;

    public constructor(startingWidth: number, startingHeight: number, debugParams?: ContainerDebugParams)
    {
        super();

        this.availableWidth = startingWidth;
        this.availableHeight = startingHeight;
        this.debugParams = debugParams;
        this.name = debugParams?.name;

        console.log(`ResponsiveView.constructor() ${this.name} startingWidth: ${startingWidth}, startingHeight: ${startingHeight}`);
    }

    public setAvailableSize(availableWidth: number, availableHeight: number)
    {
        console.log(`ResponsiveView.setAvailableSize() ${this.name} availableWidth: ${availableWidth}, availableHeight: ${availableHeight}`);
        this.availableWidth = availableWidth;
        this.availableHeight = availableHeight;
    }
}

export interface IView
{
    Create(): void;
    Destroy(): void;
}

export interface IPortraitView extends IView
{
    
}

export interface ILandscapeView extends IView
{
    
}

enum MyOrientation
{
    Portrait = "Portrait",
    Landscape = "Landscape"
}

export class ResponsiveOrientationSwitchingContainer extends ResponsiveSizeContainer
{
    protected switchRatio: number;

    protected portraitView: IPortraitView;
    protected landscapeView: ILandscapeView;

    protected currentOrientation: MyOrientation = MyOrientation.Portrait;
    protected currentView: IView;

    public constructor(switchRatio: number, percentX: number, percentY: number, percentWidth: number, percentHeight: number, maxRatio: number = NaN, debugParams?: ContainerDebugParams)
	{
		super(percentX, percentY, percentWidth, percentHeight, maxRatio, debugParams);

        this.switchRatio = switchRatio;
	}

    public SetViews(portraitView: IPortraitView, landscapeView: ILandscapeView)
    {
        this.portraitView = portraitView;
        this.landscapeView = landscapeView;
        
        this.currentOrientation = MyOrientation.Portrait;
        this.currentView = portraitView;
        this.currentView.Create();
    }

    protected override updateDebugGraphics(): void
    {
        if (!this.debugGraphics)
        {
            // no debug graphics
            return;
        }

        let color: PIXI.ColorSource = "0x00000000";
        if (this.currentOrientation == MyOrientation.Portrait)
        {
            color = this.debugParams?.color ?? color;
        }
        else if (this.currentOrientation == MyOrientation.Landscape)
        {
            color = this.debugParams?.secondaryColor ?? color;
        }
        
        // this.debugGraphics.clear();
        // this.debugGraphics.beginFill(color);
        // this.debugGraphics.drawRect(0, 0, this.calculatedWidth, this.calculatedHeight);
        // this.debugGraphics.endFill();
    }

    protected SwitchOrientation(orientation: MyOrientation): void
    {
        console.log(`ResponsiveOrientationSwitchingContainer.SwitchOrientation() orientation: ${orientation}`);
        this.currentOrientation = orientation;
    }

    public override updateTransform(): void
    {
        super.updateTransform();

        const ratio = this.calculatedWidth / this.calculatedHeight;

        if (ratio >= this.switchRatio && this.currentOrientation == MyOrientation.Portrait)
        {
            this.SwitchOrientation(MyOrientation.Landscape);
        }
        else if (ratio < this.switchRatio && this.currentOrientation == MyOrientation.Landscape)
        {
            this.SwitchOrientation(MyOrientation.Portrait);
        }
    }
}

export class FixedOrientationSwitchingContainer extends FixedSizeFitContainer
{

    protected switchRatio: number;
    protected currentOrientation: MyOrientation = MyOrientation.Portrait;


    public constructor(switchRatio:number, width: number, height: number, debugParams?: ContainerDebugParams)
    {
        super(width, height, debugParams);
        this.switchRatio = switchRatio;
    }

    protected SwitchOrientation(orientation: MyOrientation): void
    {
        console.log(`FixedOrientationSwitchingContainer.SwitchOrientation() orientation: ${orientation}`);
        this.currentOrientation = orientation;
    }

    public override updateTransform(): void
    {
        super.updateTransform();



        if (this.parent)
        {
            let parentWidth: number;
            let parentHeight: number;

            if (this.parent instanceof ResponsiveView)
            {
                parentWidth = this.parent.availableWidth;
                parentHeight = this.parent.availableHeight;
            }
            else if (this.parent instanceof FixedSizeFitContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }
            else if (this.parent instanceof ResponsiveSizeContainer)
            {
                parentWidth = this.parent.calculatedWidth;
                parentHeight = this.parent.calculatedHeight;
            }

            const ratio = parentWidth / parentHeight;

            console.log(`FixedOrientationSwitchingContainer.updateTransform() parentWidth: ${parentWidth}, parentHeight: ${parentHeight}, ratio: ${ratio}`);

            if (ratio >= this.switchRatio && this.currentOrientation == MyOrientation.Portrait)
            {
                this.SwitchOrientation(MyOrientation.Landscape);
            }
            else if (ratio < this.switchRatio && this.currentOrientation == MyOrientation.Landscape)
            {
                this.SwitchOrientation(MyOrientation.Portrait);
            }
        }
    }
}

export interface IGridResponsiveProps{
    internalColumns : number;
    internalRows : number;
}

export class ResponsivePaytable extends PIXI.Container implements IGridResponsiveProps {
    
    public internalColumns: number = null;
    public internalRows: number = null;
    public selectedColumn: number = null;
    public selectedRow: number = null;
    public horizontalGap: number = null;
    public verticalGap: number = null;
    // protected ColumnIndexMap: Map<number, FixedSizeFitContainer> = new Map<number, FixedSizeFitContainer>();

    public constructor(params : IGridResponsiveProps){
        super();

        if (params.internalColumns < 1 || params.internalRows < 1) {
            throw new Error("GridResponsive must have at least 1 column and 1 row");
        }

        this.internalColumns = params.internalColumns;
        this.internalRows = params.internalRows;

        this.CreateResponsiveView();
    }

    protected responsiveView : ResponsiveView = null;
    private responsiveSizeContainer : ResponsiveSizeContainer = null;
    private fixedSizeContainer : FixedSizeFitContainer = null;
    private gridContainer: PIXI.Container = null;
    private titleContainer: PIXI.Container = null;

    private CreateResponsiveView(){

        this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: 'responsive-view' });
        this.addChild(this.responsiveView);

        this.responsiveSizeContainer = new ResponsiveSizeContainer(0.05, 0, 0.9, 0.265, NaN, { color: 0x990000, name: 'responsive-size-container' });
        this.responsiveView.addChild(this.responsiveSizeContainer);

        this.fixedSizeContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0x990000, name: 'responsive-size-container' });
        this.responsiveSizeContainer.addChild(this.fixedSizeContainer);

        this.titleContainer = new PIXI.Container();
        this.titleContainer.name = "title";
        this.fixedSizeContainer.addChild(this.titleContainer);

        this.gridContainer = new PIXI.Container();
        this.gridContainer.name = "paytableContainer";
        this.fixedSizeContainer.addChild(this.gridContainer);

        // const internalWidth = this.fixedSizeContainer.fixedWidth / this.internalColumns;
        

        // const positionX = internalWidth / this.internalColumns;


        // for (let i = 0; i < this.internalColumns; i++){

        //     // const internalResponsiveSizeContainer = new ResponsiveSizeContainer((i * this.percentX), 0, 1, 1, NaN, { color: 0x990000, name: `responsive-size-container-${i+1}` });
        //     // this.fixedSizeContainer.addChild(internalResponsiveSizeContainer);

        //     const internalFixedContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0x990000, name: `responsive-size-container-internal-${i+1}` });
        //     this.ColumnIndexMap.set(i, internalFixedContainer);
        //     internalResponsiveSizeContainer.addChild(internalFixedContainer);

        // }        
    }
    private CheckGridSize(columns: number, rows: number): { isValid: boolean, message?: string } {
        if (columns > this.internalColumns) {
            return { isValid: false, message: `Column number out of range ${columns} > ${this.internalColumns}`};
        }
        if (rows > this.internalRows) {
            return { isValid: false, message: `Row number out of range ${rows} > ${this.internalRows}`};
        }
        return { isValid: true };
    }

    // public View(): ResponsiveView
    // {
    //     return this.responsiveView;
    // }

    public AddChildInPositionScaled(child: PIXI.Container, coordinate: Point): void
    {
        const isGridOk = this.CheckGridSize(coordinate.x, coordinate.y);
        
        if (!isGridOk.isValid) {
            throw new Error(isGridOk.message);
        }

        this.selectedColumn = coordinate.x;
        this.selectedRow = coordinate.y;

        const internalWidth = this.fixedSizeContainer.fixedWidth / this.internalColumns;
        const internalHeight = this.fixedSizeContainer.fixedHeight / this.internalRows;

        this.gridContainer.addChild(child);


        // const internalFixedSizeContainer = this.ColumnIndexMap.get(columNumber);
        // const childContainer = new PIXI.Container();
        // childContainer.addChild(child);
        // internalFixedSizeContainer.addChild(childContainer);

        const scaleX = internalWidth / child.width;
        const scaleY = internalHeight / child.height;
        const scale = Math.min(scaleX, scaleY);

        child.scale.set(scale);
        child.position.x = internalWidth * coordinate.x;
        child.position.y = internalHeight * coordinate.y;
        // this.setInternalPosition();

        // child.position.x = 0;//(internalWidth * columNumber)- child.width / 2;//internalFixedSizeContainer.fixedWidth / 2 - (child.width * scale) / 2;//internalFixedSizeContainer.fixedWidth / 2;
        // child.position.y = internalHeight * rowNumber;
        // childContainer.scale.set(scale);
        // childContainer.position.x = 0;//(internalWidth * columNumber)- child.width / 2;//internalFixedSizeContainer.fixedWidth / 2 - (child.width * scale) / 2;//internalFixedSizeContainer.fixedWidth / 2;
        // childContainer.position.y = internalHeight * rowNumber;

    }

    public AddChildInPositionNoScaled(child: PIXI.Container, coordinate: Point): void{

        const isGridOk = this.CheckGridSize(coordinate.x, coordinate.y);
        
        if (!isGridOk.isValid) {
            throw new Error(isGridOk.message);
        }

        this.gridContainer.addChild(child);
        
        const internalWidth = this.fixedSizeContainer.fixedWidth / this.internalColumns;
        const internalHeight = this.fixedSizeContainer.fixedHeight / this.internalRows;

        this.selectedColumn = coordinate.x * internalWidth;
        this.selectedRow = coordinate.y * internalHeight;

        child.position.x = internalWidth * coordinate.x;
        child.position.y = internalHeight * coordinate.y;
        // this.setInternalPosition();

    }
    protected titleSize = new Size(930, 300);


    public AddTitle(child: PIXI.Sprite): void{
        this.titleContainer.addChild(child);
        this.titleContainer.pivot.set(this.titleContainer.width / 2, this.titleContainer.height / 2);

        // const scaleX = this.titleSize.Width / this.fixedSizeContainer.fixedWidth //this.fixedSizeContainer.fixedWidth  / child.width;
        // const scaleY = this.titleSize.Height / this.fixedSizeContainer.fixedHeight //this.fixedSizeContainer.fixedHeight / child.height;
        // const scale = Math.min(scaleX, scaleY);
        // child.scale.set(scale);
        // child.position.x = this.fixedSizeContainer.fixedWidth / 2 - this.titleSize.Width / 2;
        // this.gridContainer.position.y = this.titleContainer.height;
    }

    // private setInternalPosition(){
    //     this.gridContainer.position.x = this.fixedSizeContainer.fixedWidth / 2 - this.gridContainer.width / 2;
    //     this.gridContainer.position.y = this.fixedSizeContainer.fixedHeight / 2 - this.gridContainer.height / 2;

    // }

    public Resize(): void{
        this.SetToDefault();
        this.responsiveView.setAvailableSize(window.innerWidth, window.innerHeight);

        const scaleX = this.titleSize.Width / this.fixedSizeContainer.fixedWidth //this.fixedSizeContainer.fixedWidth  / child.width;
        const scaleY = this.titleSize.Height / this.fixedSizeContainer.fixedHeight //this.fixedSizeContainer.fixedHeight / child.height;
        const scale = Math.min(scaleX, scaleY);
        this.titleContainer.scale.set(scale);
        this.titleContainer.position.x = this.fixedSizeContainer.fixedWidth / 2;
        this.titleContainer.position.y = this.fixedSizeContainer.fixedHeight / 8;//this.fixedSizeContainer.fixedHeight / 2;

        this.gridContainer.position.y = this.fixedSizeContainer.fixedHeight / 2
        
        if (GetOrientation() == Orientation.Landscape){
            this.gridContainer.visible = false
            this.titleContainer.position.y = this.fixedSizeContainer.fixedHeight / 4;
            // this.responsiveSizeContainer.percentWidth = 1;
            this.responsiveSizeContainer.percentHeight = 0.265;

            return;
        }
        

        this.responsiveSizeContainer.percentHeight = 0.265;
        this.gridContainer.visible = true;

        // this.gridContainer.position.x = (this.gridContainer.width - this.fixedSizeContainer.fixedWidth) / 2 ; 
        // this.gridContainer.position.y = this.gridContainer.height - this.fixedSizeContainer.fixedHeight / 2; 

    }

    private SetToDefault(){
        this.titleContainer.scale.set(1);
        this.titleContainer.position.set(0, 0);

    }
}


// export class JackpotView extends ResponsiveOrientationSwitchingContainer
// {
//     jp4container: ResponsiveSizeContainer;
//     jp3container: ResponsiveSizeContainer;
//     jp2container: ResponsiveSizeContainer;
//     jp1container: ResponsiveSizeContainer;

//     logoContainer: ResponsiveSizeContainer;

//     public constructor(switchRatio: number, x: number, y: number, width: number, height: number, maxRatio: number = NaN, debugParams?: ContainerDebugParams)
// 	{
// 		super(switchRatio, x, y, width, height, maxRatio, debugParams);

//         this.CreateLandscape();
//     }

//     override SwitchOrientation(orientation: MyOrientation): void
//     {
//         super.SwitchOrientation(orientation);

//         if (orientation == MyOrientation.Portrait)
//         {
//             this.DestroyLandscape();
//             this.CreatePortrait();
//         }
//         else
//         {
//             this.DestroyPortrait();
//             this.CreateLandscape();
//         }
//     }
    
//     CreateLandscape(): void
//     {
//         const margin = 0.01;
//         this.jp4container = new ResponsiveSizeContainer(0.00 + margin, 0.00 + margin, 0.50 - 2*margin, 0.60 - 2*margin, NaN, {color: 0x000099, name: 'jp4-container'});  
//         this.addChild(this.jp4container);

//         this.jp3container = new ResponsiveSizeContainer(0.50 + margin, 0.00 + margin, 0.50 - 2*margin, 0.60 - 2*margin, NaN,{color: 0x000099, name: 'jp3-container'});
//         this.addChild(this.jp3container);

//         this.jp2container = new ResponsiveSizeContainer(0.10 + margin, 0.60 + margin, 0.30 - 2*margin, 0.40 - 2*margin, NaN,{color: 0x000099, name: 'jp2-container'});  
//         this.addChild(this.jp2container);

//         this.jp1container = new ResponsiveSizeContainer(0.60 + margin, 0.60 + margin, 0.30 - 2*margin, 0.40 - 2*margin, NaN,{color: 0x000099, name: 'jp1-container'});
//         this.addChild(this.jp1container);
//     }

//     DestroyLandscape(): void
// 	{
// 		this.jp4container.destroy();
// 		this.jp3container.destroy();
// 		this.jp2container.destroy();
// 		this.jp1container.destroy();
//         this.logoContainer?.destroy();
// 	}

//     CreatePortrait(): void
//     {
//         const margin = 0.01;
//         this.jp4container = new ResponsiveSizeContainer(0.00 + margin, 0.00 + margin, 1 - 2*margin, 0.33 - 2*margin, NaN, {color: 0x000099, name: 'jp4-container'});
//         this.addChild(this.jp4container);

//         this.jp3container = new ResponsiveSizeContainer(0.05 + margin, 0.33 + margin, 0.9 - 2*margin, 0.33 - 2*margin, NaN, {color: 0x000099, name: 'jp3-container'});
//         this.addChild(this.jp3container);

//         this.jp2container = new ResponsiveSizeContainer(0.05 + margin, 0.66 + margin, 0.25 - 2*margin, 0.33 - 2*margin, NaN, {color: 0x000099, name: 'jp2-container'});  
//         this.addChild(this.jp2container);

//         this.logoContainer = new ResponsiveSizeContainer(0.30 + margin, 0.66 + margin, 0.40 - 2*margin, 0.33 - 2*margin, NaN, {color: 0x000099, name: 'logo-container'});
//         this.addChild(this.logoContainer);

//         this.jp1container = new ResponsiveSizeContainer(0.70 + margin, 0.66 + margin, 0.25 - 2*margin, 0.33 - 2*margin, NaN, {color: 0x000099, name: 'jp1-container'});
//         this.addChild(this.jp1container);
//     }

//     DestroyPortrait(): void
// 	{
//         this.jp4container.destroy();
// 		this.jp3container.destroy();
// 		this.jp2container.destroy();
// 		this.jp1container.destroy();
//         this.logoContainer?.destroy();
// 	}
// }
